<template>
  <div v-if="menu" :class="slug">
    <div 
      v-for="(item, index) in menu.items" 
      :key="index"
      :class="slug + '-item'">
        <router-link v-if="item.page" :to="'/' + item.page.slug">{{item.label}}</router-link>
        <a v-if="item.url" :href="item.url" :style="imageLink(item)">{{item.label}}</a>
      </div>
  </div>
</template>

<script>

import gql from 'graphql-tag'

export default {
  name: 'Menu',
  props: [
    'id',
    'slug'
  ],
  data() {
    return {
      menu: {}
    }
  },
  apollo: {
    menu: {
      query: gql`query Menu ($id: ItemId) {
        menu (filter: {id: {eq: $id}}) {
          items {
            ... on PageLinkRecord {
              label
              image {
                url
              }
              page {
                slug
              }
            }
            ... on ExternalLinkRecord {
              label
              image {
                url
              }
              url
            }
          }
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      },
      prefetch({route}) {
        return {
          id: route.params.id
        }
      }
    }
  },
  methods: {
    imageLink(item) {
      if (item.image) {
        return "background-image: url(" + item.image.url + ")";
      }
    }
  }
}
</script>

<style scoped lang="less">

</style>
